import styled from "styled-components";

export const IdWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  .inputWrapper {
    width: 75%;
    @media only screen and (min-width: 992px) and (max-width: 1199px) {
      width: 70%;
    }

    @media only screen and (min-width: 480px) and (max-width: 667px) {
      width: 70%;
    }

    @media only screen and (max-width: 480px) {
      width: 65%;
    }
  }

  button {
    width: calc(100% - 79%);

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
      width: calc(100% - 74%);
    }

    @media only screen and (min-width: 480px) and (max-width: 667px) {
      width: calc(100% - 74%);
    }

    @media only screen and (max-width: 480px) {
      width: calc(100% - 69%);
    }
  }

  input {
    width: 100%;
    height: 64px;
    border: 1px solid #ececec;
    padding-left: 20px;
    background: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
  }

  .form-input {
    height: 50px;
  }

  input:focus {
    background: transparent;
    border-color: #bce3c9;
  }

  .input-invalid-red {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-red:focus {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-msg {
    padding-top: 1px;
    padding-left: 0.3rem;
    color: #c10000;
    font-size: 0.8rem;
  }
`;

export const PasswordWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  .pwInputWrapper {
    width: 48%;
  }

  input {
    width: 100%;
    height: 64px;
    border: 1px solid #ececec;
    padding-left: 20px;
    background: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
  }

  .form-input {
    height: 50px;
  }

  input:focus {
    background: transparent;
    border-color: #bce3c9;
  }

  .input-invalid-red {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-red:focus {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-msg {
    padding-top: 1px;
    padding-left: 0.3rem;
    color: #c10000;
    font-size: 0.8rem;
  }
`;

export const NameEmailWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  .nameInputWrapper {
    width: 28%;
  }

  .emailInputWrapper {
    width: 68%;
  }

  input {
    width: 100%;
    height: 64px;
    border: 1px solid #ececec;
    padding-left: 20px;
    background: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
  }

  .form-input {
    height: 50px;
  }

  input:focus {
    background: transparent;
    border-color: #bce3c9;
  }

  .input-invalid-red {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-red:focus {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-msg {
    padding-top: 1px;
    padding-left: 0.3rem;
    color: #c10000;
    font-size: 0.8rem;
  }
`;

export const PhoneWrapper = styled.div`
  margin-bottom: 1rem;

  .inputBtnWrapper {
    display: flex;
    justify-content: space-between;
  }

  .inputWrapper,
  .isConfirmed > input {
    color: #b6b6b6;
    cursor: not-allowed;
  }

  .inputWrapper {
    width: 70%;

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
      width: 65%;
    }

    @media only screen and (min-width: 480px) and (max-width: 667px) {
      width: 68%;
    }

    @media only screen and (max-width: 480px) {
      width: 58%;
    }
  }

  button {
    width: calc(100% - 74%);

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
      width: calc(100% - 69%);
    }

    @media only screen and (min-width: 480px) and (max-width: 667px) {
      width: calc(100% - 74%);
      font-size: 12px;
    }

    @media only screen and (max-width: 480px) {
      width: calc(100% - 62%);
      font-size: 12px;
    }
  }

  input {
    width: 100%;
    height: 64px;
    border: 1px solid #ececec;
    padding-left: 20px;
    background: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
  }

  .form-input {
    height: 50px;
  }

  input:focus {
    background: transparent;
    border-color: #bce3c9;
  }

  .input-invalid-red {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-red:focus {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-msg {
    padding-top: 1px;
    padding-left: 0.3rem;
    color: #c10000;
    font-size: 0.8rem;
  }
`;

export const PhoneCheckedWrapper = styled.div`
  margin-bottom: 1rem;

  .inputBtnWrapper {
    display: flex;
    justify-content: space-between;
  }

  .inputWrapper {
    position: relative;
    width: 70%;

    .timeCounter {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 12px;
      color: #c10000;
    }

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
      width: 65%;
    }

    @media only screen and (min-width: 480px) and (max-width: 667px) {
      width: 68%;
    }

    @media only screen and (max-width: 480px) {
      width: 58%;
    }
  }

  button {
    width: calc(100% - 74%);

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
      width: calc(100% - 69%);
    }

    @media only screen and (min-width: 480px) and (max-width: 667px) {
      width: calc(100% - 74%);
    }

    @media only screen and (max-width: 480px) {
      width: calc(100% - 62%);
    }
  }

  input {
    width: 100%;
    height: 64px;
    border: 1px solid #ececec;
    padding-left: 20px;
    background: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
  }

  .form-input {
    height: 50px;
  }

  input:focus {
    background: transparent;
    border-color: #bce3c9;
  }

  .input-invalid-red {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-red:focus {
    height: 50px;
    border: 1px solid #c10000;
  }

  .input-invalid-msg {
    padding-top: 1px;
    padding-left: 0.3rem;
    color: #c10000;
    font-size: 0.8rem;
  }
`;

export const UsagesWrapper = styled.div`
  margin-bottom: 1rem;

  .infoWrapper {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    font-size: 1rem;
    word-break: keep-all;
    margin-bottom: 10px;

    .subTitle {
      margin-right: 5px;
    }

    .example {
      background-color: #b6b6b6;
      padding: 3px;
      border-radius: 10px;
      color: #fff;
      font-size: 0.8rem;
      word-break: keep-all;

      @media only screen and (min-width: 480px) and (max-width: 667px) {
        font-size: 12px;
      }

      @media only screen and (max-width: 480px) {
        font-size: 12px;
      }
    }
  }

  input {
    width: 100%;
    height: 64px;
    border: 1px solid #ececec;
    padding-left: 20px;
    background: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
  }

  .form-input {
    height: 50px;
  }

  input:focus {
    background: transparent;
    border-color: #bce3c9;
  }
`;
